import { useQuery } from '@tanstack/react-query';

import { fetchAllergyList } from '../../../apis/allergy';

import { getAllergyListParams } from './types';

function useAllergyList(params: getAllergyListParams) {
  const { id } = params;

  const { data, isLoading, isError, isRefetching } = useQuery({
    queryKey: ['allergy-list'],
    queryFn: () => fetchAllergyList(id),
  });

  return {
    isLoading: isLoading,
    isRefetching: isRefetching,
    isError: isError,
    allergies: data,
  };
}

export default useAllergyList;
